import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/rem.js'

import './assets/font/iconfont.css'
import './assets/public.css'

import ElementUI from 'element-ui';
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css';


Vue.prototype.baseURL='http://exam.ah1d.com'

import axios from 'axios'
Vue.prototype.$http=axios

Vue.filter('typeFilter', function (type) {
  switch(type){
    case 1:
      return '单选题'
    case 2:
      return '选择题'
    case 3:
      return '多选题'
  }

})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
